import { render } from "./AlertNote.vue?vue&type=template&id=7b996a46"
import script from "./AlertNote.vue?vue&type=script&lang=js"
export * from "./AlertNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__